import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, TransactionSyncAddEdit } from './Pages';

export const TransactionSync = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing} />
        <Route exact path = {`${match.path}/addEdit`} component={TransactionSyncAddEdit} />
    </Fragment>
)